import api from 'api';
import Recipe from 'records/Recipe';
import Menu from 'records/Menu';

export const RECIPE_ASYNC_ACTION_START = 'RECIPE_ASYNC_ACTION_START';
export const RECIPE_ASYNC_ACTION_ERROR = 'RECIPE_ASYNC_ACTION_ERROR';
export const RECIPE_ASYNC_UPDATE_ACTION_SUCCESS = 'RECIPE_ASYNC_UPDATE_ACTION_SUCCESS';
export const RECIPE_ASYNC_ARCHIVE_ACTION_SUCCESS = 'RECIPE_ASYNC_ARCHIVE_ACTION_SUCCESS';
export const RECIPE_UPDATE_ACTION_SUCCESS = 'RECIPE_UPDATE_ACTION_SUCCESS';
export const RECIPE_RESET_STATE = 'RECIPE_RESET_STATE';
export const RECIPE_ASYNC_DELETE_ACTION_SUCCESS = 'RECIPE_ASYNC_DELETE_ACTION_SUCCESS';
export const RECIPE_ACTION_SUCCESS = 'RECIPE_ACTION_SUCCESS';

// fire when only update partial data of the recipe
export const RECIPE_ASYNC_PARTIAL_UPDATE_SUCCESS = 'RECIPE_ASYNC_PARTIAL_UPDATE_SUCCESS';

function formattedRecipesList(data, menus) {
  let recipe = data;
  recipe.get('usedInMenus').map((menu) => {
    const findMenu = Menu.filterMenuById(menus, menu.get('menuId'));
    const currIndex = recipe.get('usedInMenus').findIndex((value) => {
      return value.get('menuId') === menu.get('menuId');
    });
    if (findMenu.size === 0) {//remove invalid menu list in usedInMenus
      recipe = recipe.deleteIn(['usedInMenus', currIndex]);
    } else {
      recipe = recipe.setIn(['usedInMenus', currIndex, 'menuTitle'], findMenu.first().title);
    }
  });
  return recipe;
}

function recipeAsyncActionStart() {
  return {
    type: RECIPE_ASYNC_ACTION_START,
  };
}

function recipeAsyncActionError(error) {
  return {
    type: RECIPE_ASYNC_ACTION_ERROR,
    error,
  };
}

function recipeAsyncUpdateSuccess(data) {
  return {
    type: RECIPE_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

function recipeAsyncArchiveSuccess() {
  return {
    type: RECIPE_ASYNC_ARCHIVE_ACTION_SUCCESS,
  };
}

function recipeActionSuccess() {
  return {
    type: RECIPE_ACTION_SUCCESS,
  };
}

function recipeAsyncDeleteSuccess() {
  return {
    type: RECIPE_ASYNC_DELETE_ACTION_SUCCESS,
  };
}

export function updateRecipe(data) {
  return {
    type: RECIPE_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function resetRecipeState() {
  return {
    type: RECIPE_RESET_STATE,
  };
}

function recipePartialAsyncUpdateSuccess(data) {
  return {
    type: RECIPE_ASYNC_PARTIAL_UPDATE_SUCCESS,
    data,
  };
}

function handleUpdate(recipe, method, errMsg) {
  return (dispatch, getState) => {
    dispatch(recipeAsyncActionStart());
    return api.request('recipe', method, recipe, api.contentTypes.form)
      .then((data) => {
        const menus = getState().menus.get('data');
        const recipeData = formattedRecipesList(new Recipe(data), menus);
        dispatch(updateRecipe(recipeData));
        return recipeData;
      })
      .catch((err) => {
        dispatch(recipeAsyncActionError(errMsg));
        throw (err);
      });
  };
}

export function createRecipeAsync(recipe) {
  return handleUpdate(recipe, 'post', 'Unable to create recipe');
}

export function updateRecipeAsync(recipe) {
  return handleUpdate(recipe, 'put', 'Unable to update recipe');
}

// for Partially update Ingredients Batch Recipe
export function updatePartialRecipeAsync(formData, recipe) {
  return (dispatch, getState) => {
    
    // update the value to store immediately
    const partialModifiedData = {
      recipeName: recipe.get('recipeName'),
      yield: recipe.get('yield'),
      servings: recipe.get('servings'),
      note: recipe.get('note'),
      prepTimeMinutes: recipe.get('prepTimeMinutes'),
      cookTimeMinutes: recipe.get('cookTimeMinutes'),
      price: recipe.get('price'),
      description: recipe.get('description'),
    };
    dispatch(recipePartialAsyncUpdateSuccess(partialModifiedData));
    dispatch(recipeAsyncActionStart());
    return api.request('recipe', 'put', formData, api.contentTypes.form)
    .then((data) => {
      const partialAffectedData = {
        costPerServing: data.costPerServing,
        costPerRecipe: data.costPerRecipe,
        price: data.price,
        profit: data.profit,
        costPercent: data.costPercent,
        description: data.description,
      };
      dispatch(recipePartialAsyncUpdateSuccess(partialAffectedData));
      return data;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to update batch recipe'));
      throw (err);
    });
  };
}

export function getRecipeAsync(id) {
  return (dispatch, getState) => {
    dispatch(recipeAsyncActionStart());
    return api.request(`recipe/?recipeId=${ id }`, 'get')
    .then((data) => {
      //remove invalid menu list in usedInMenus
      const menus = getState().menus.get('data');
      const recipe = formattedRecipesList(new Recipe(data), menus);
      dispatch(updateRecipe(recipe));
      return data;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to get recipe'));
      throw (err);
    });
  };
}

export function getRecipeList(id) {
  return (dispatch, getState) => {
    
    return api.request(`recipe/?recipeId=${ id }`, 'get')
    .then((data) => {
      //remove invalid menu list in usedInMenus
      const menus = getState().menus.get('data');
      const recipe = formattedRecipesList(new Recipe(data), menus);
      dispatch(updateRecipe(recipe));
      return data;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to get recipe'));
      throw (err);
    });
  };
}

export function archiveRecipeAsync(recipeId) {
  return (dispatch, getState) => {
    
    return api.request(`recipe/archive/${ recipeId }`, 'post')
    .then((data) => {
      dispatch(recipeAsyncArchiveSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to archive recipe'));
      throw (err);
    });
  };
}

export function deleteRecipeAsync(recipeId) {
  return (dispatch, getState) => {
    
    return api.request(`recipe/${ recipeId }`, 'delete')
    .then((data) => {
      dispatch(recipeAsyncDeleteSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to delete recipe'));
      throw (err);
    });
  };
}

export function restoreArchiveRecipeAsync(recipeId) {
  return (dispatch, getState) => {
    
    return api.request(`recipe/restoreArchive/${ recipeId }`, 'post')
    .then((data) => {
      dispatch(recipeAsyncArchiveSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to create recipe'));
      throw (err);
    });
  };
}

// for Ingredients Batch Recipe
export function createBatchRecipeAsync(recipe) {
  return (dispatch, getState) => {
    dispatch(recipeAsyncActionStart());
    return api.request('recipe', 'post', recipe, api.contentTypes.form)
    .then((data) => {
      dispatch(recipeAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to create batch recipe'));
      throw (err);
    });
  };
}

export function updateBatchRecipeAsync(recipe) {
  return (dispatch, getState) => {
    dispatch(recipeAsyncActionStart());
    return api.request('recipe', 'put', recipe, api.contentTypes.form)
    .then((data) => {
      dispatch(recipeAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to update batch recipe'));
      throw (err);
    });
  };
}

export function getBatchRecipeAsync(id, doCostRollUp) {
  return (dispatch, getState) => {
    dispatch(recipeAsyncActionStart());
    return api.request(`recipe/?recipeId=${ id }&doCostRollUp=${ doCostRollUp }`, 'get')
    .then((data) => {
      dispatch(recipeAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to get batch recipe'));
      throw (err);
    });
  };
}

export function updateBatchRecipeBatchLevel(recipe) {
  return (dispatch, getState) => {
    dispatch(recipeAsyncActionStart());
    return api.request('recipe/batchLevel ', 'put', recipe)
    .then((data) => {
      dispatch(recipeAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to update batch recipe batchLevel'));
      throw (err);
    });
  };
}

export function updateRecipeVisibilityAsync(recipeId, visible, originalVisibility) {
  return (dispatch, getState) => {
    

    // set the flag immediately to make toggle switch respose promptly
    const partialModifiedData = { visible };
    dispatch(recipePartialAsyncUpdateSuccess(partialModifiedData));

    return api.request(`recipe/${ recipeId }/visibility/${ visible }`, 'put')
    .then((data) => {
      // set the flag again once confirmed
      const resetData = { visible };
      dispatch(recipePartialAsyncUpdateSuccess(resetData));
      return data;
    })
    .catch((err) => {
      // reset if update fails
      const resetData = { visible: originalVisibility };
      dispatch(recipePartialAsyncUpdateSuccess(resetData));
      dispatch(recipeAsyncActionError('Unable to update recipe visibility'));
      throw (err);
    });
  };
}

export function checkIfRecipeLocked(id) {
  return (dispatch, getState) => {
    
    return api.request(`recipe/lock/${ id }`, 'get')
    .then((data) => {
      return data;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to check recipe status'));
      throw (err);
    });
  };
}

export function unlockRecipe(id) {
  return (dispatch, getState) => {
    
    return api.request(`recipe/unlock/${ id }`, 'put')
    .then(() => {
      return true;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to unlock recipe status'));
      throw (err);
    });
  };
}

export function addRecipeToMenu(formData) {
  return (dispatch, getState) => {
    
    return api.request('menuItem/from-recipe', 'post', formData)
    .then(() => {
      return true;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to add recipe to menu'));
      throw (err);
    });
  };
}

export function moveToBatchRecipe(recipeId) {
  return (dispatch, getState) => {
    dispatch(recipeAsyncActionStart());
    return api.request(`recipe/moveToBatchRecipe/${recipeId}`, 'put')
    .then(() => {
      dispatch(recipeActionSuccess());
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to move regular recipe to batch recipe'));
      throw (err);
    })
  }
}

export function createRecipeFromExcel(file, categoryId) {
  return (dispatch, getState) => {
    dispatch(recipeAsyncActionStart());
    return api.request(`recipe/excelUpload?categoryId=${ categoryId }`, 'post', file, api.contentTypes.form)
    .then((data) => {
      dispatch((recipeAsyncUpdateSuccess(data)));
      return data;
    })
    .catch((err) => {
      dispatch(recipeAsyncActionError('Unable to create recipe from excel'));
      throw (err);
    });
  };
}
